<template>
  <v-container>

    <!-- Ficha de una entrega -->
    <card-confirm-entrega
        @clickEnOk="clickEnOK()"
        @clickEnParcial="clickEnParcial()"
        @clickEnNo="clickEnNo()"
        @clickEnCancelar="clickEnCancelar()"
        @clickEnVerMapa="clickEnVerMapa()"
        :entrega-seleccionada="entregaSeleccionada"
    />

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="600"
        v-model="dialog"
    >
      <v-card>
        <v-card-title class="subtitle-1 font-weight-bold grey lighten-2">
          <span>Persona que recibe el pedido</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                  cols="12"
                  sm="6"
                  md="4"
              >
                <v-text-field
                    v-model="nombreReceptor"
                    label="Nombre y Apellido"
                    required
                    :rules="[rules.required, rules.largoMinimo]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small>Indique el nombre de la persona que recibió el pedido</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="black darken-1"
              text
              small
              @click="clickEnCancelacionDialogo()"
          >
            Cancelar
          </v-btn>
          <v-btn
              color="blue darken-1"
              outlined
              text
              :disabled="!nombreReceptor"
              @click="clickEnConfirmacionDialogo()"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Lista de entregas pendientes -->
    <v-row class="mb-1">
      <v-col>
        <v-btn @click="clickEnActualizar()" color="green" block dark v-if="entregaSeleccionada==null">
          <div class="itemUnaEntrega">Actualizar
            <v-icon :class="getClassBotonActualizar()">mdi-refresh</v-icon>
          </div>
        </v-btn>
      </v-col>
    </v-row>
    <v-alert
        icon="mdi-truck"
        color="primary"
        dark
        elevation="5"
        border="left" class="py-3 mt-0 mb-1 itemEntrega" v-if="entregaSeleccionada==null">
      {{ getTituloListaEntregas() }}
    </v-alert>
    <div v-if="entregaSeleccionada==null">

      <CardInfoEntrega
          v-for="(item, index) in listaEntregas" :key="index"
          @click-en-entrega="clickEnEntrega(item)"
          :item="item"
      />

    </div>

  </v-container>
</template>

<style scoped>
.itemUnaEntrega {
  font-weight: 900;
  font-family: "Helvetica Neue";
}

.itemEntrega {
  color: white;
  font-size: 16px;
  font-weight: 900;
  font-family: "Helvetica Neue";
}
</style>

<script>
import choferes from "@/store/choferes"
import store from "@/store"
import fechas from "vue-lsi-util/fechas"
import CardConfirmEntrega from "../components/CardConfirmEntrega";
import CardInfoEntrega from "../components/CardInfoEntrega";
import CardConfirm from "../components/CardConfirm";


export default {
  name: "VerRutaActual",
  components: {CardConfirm, CardInfoEntrega, CardConfirmEntrega},
  data() {
    return {
      dialog: false,
      rules: {
        required: value => !!value || 'Campo requerido',
        largoMinimo: value => value.length >= 5 || 'Demasiado corto',
        nombres: value => {
          const pattern = new RegExp('^[a-zA-Z ]*$');
          return pattern.test(value) || 'Nombre inválido'
        }
      },
      nombreReceptor: '',
      listaEntregas: [],
      entregaSeleccionada: null,
      estaActualizando: false,
      fechaHoy: '',
      tipoEntregaActual: '',
      hashFile: ''
    }
  },

  methods: {
    getClassBotonActualizar() {
      if (this.estaActualizando) {
        return "mdi-spin"
      } else {
        return ""
      }
    },
    getTituloListaEntregas() {
      if (this.listaEntregas.length > 0) {
        return this.fechaHoy + " - V: " + this.listaEntregas[0].Ventana + " - Entregas: " + this.listaEntregas.length
      } else {
        return this.fechaHoy + " - Sin entregas para hoy"
      }
    },
    getEntregas() {
      this.estaActualizando = true
      choferes.actions.getEntregasPendientes(store.state.choferes.choferActual.numero, this.fechaHoy)
          .then(respuesta => {
            this.listaEntregas = respuesta
            this.listaEntregas.sort((a, b) => {
              if (a.OrdenEntrega > b.OrdenEntrega) {
                return 1
              } else {
                return -1
              }
            })
          })
          .catch(puteada => {
            console.log("Error", puteada)
          })
          .finally(() => {
            this.estaActualizando = false
          })
    },
    clickEnActualizar() {
      this.getEntregas()
    },
    clickEnVerMapa() {
      if (this.entregaSeleccionada.Latitud === 0) {
        window.open("http://maps.google.com/maps?q=" + this.entregaSeleccionada.Domicilio + ", " + this.entregaSeleccionada.Localidad, "_blank").focus()
      } else {
        window.open("http://maps.google.com/maps?q=" + this.entregaSeleccionada.Latitud + "," + this.entregaSeleccionada.Longitud, "_blank").focus()
      }
    },
    clickEnCancelar() {
      this.entregaSeleccionada = null
    },

    clickEnConfirmacionDialogo() {
      this.dialog = false
      if (this.tipoEntregaActual === "C") {
        this.clickEnOKConfirmado()
      } else {
        this.clickEnParcialConfirmado()
      }
    },

    clickEnOK() {
      this.tipoEntregaActual = "C"
      this.dialog = true
    },
    clickEnOKConfirmado() {
      this.estado = "ENTREGADO"
      this.registrarEntregaEntregada()
    },
    clickEnParcial() {
      this.tipoEntregaActual = "P"
      this.dialog = true
    },
    clickEnParcialConfirmado() {
      this.estado = "PARCIAL"
      this.registrarEntregaEntregada()
    },
    clickEnNo() {
      this.estado = "NO ENTREGADO"
      this.registrarEntregaEntregada()
    },
    clickEnCancelacionDialogo() {
      this.dialog = false
      this.nombreReceptor = ''
      this.estado = ''
    },

    registrarEntregaEntregada() {
      const confirmacion = {
        titulo: this.estado + " - Confirma?",
        mensaje: "Confirma la registración del estado <b>" + this.estado + "</b> para el despacho seleccionado?",
        botonPrimario: "OK",
        botonSecundario: "Cancelar",
        callback: respuesta => {
          if (respuesta === "OK") {
            this.registrarEntregaEntregadaConfirmado()
          }
        }
      }
      store.dispatch("alertDialog/mostrar", confirmacion)
    },

    registrarEntregaEntregadaConfirmado() {

      choferes.actions.registrarEntregaEntregada(this.entregaSeleccionada.Id,
          store.state.choferes.choferActual.numero,
          this.fechaHoy,
          this.estado,
          this.nombreReceptor
      )
          .then(async respuesta => {
            await this.guardar()
            const ubicacionEntrega = this.listaEntregas.indexOf(this.entregaSeleccionada)
            this.listaEntregas.splice(ubicacionEntrega, 1)
            this.entregaSeleccionada = null
            this.nombreReceptor = ''
            this.dialog = false
          })
          .catch(puteada => {
            this.mostrarError(puteada)
          })

    },
    async guardar() {
      try {
        if (this.entregaSeleccionada.PedirFotoDocumentacionEntrega ||Object.is(this.estado,"NO ENTREGADO")) {


          const result = await this.gestorCargue()

          if (result.success) {

            await this.$store.dispatch("alertDialog/mostrar",
                {
                  titulo: 'Éxito!',
                  botonPrimario: "Aceptar",
                  mensaje: 'El documento ha sido registrado exitosamente',

                })
            // this.closeFoto()
            // this.$emit(this.estadoEntrega, this.hashNano)
          }
        }
      } catch (error) {
        console.log("Error en hash", error);
        await this.$store.dispatch("snackbar/mostrar", error)
      }
    },

    gestorCargue() {
      const el = this
      const functions = {
        'ENTREGADO': async () => {
          await el.$store.dispatch("choferes/registrarhashDocumentacionEntrega", el.entregaSeleccionada.Id)
          return await el.$store.dispatch("choferes/uploadFileToAws")
        },
        'PARCIAL': async () => {
          await el.$store.dispatch("choferes/registrarhashDocumentacionEntrega", el.entregaSeleccionada.Id)
          return await el.$store.dispatch("choferes/uploadFileToAws")
        },
        'NO ENTREGADO': async () => {
          return await el.$store.dispatch("choferes/uploadFileToAws")
        }
      }

      return new Promise(async (resolve, reject) => {
        try {
          const response = await functions[this.estado]()
          if (response) resolve(response)
        } catch (e) {
          reject(e)
        }
      })

    },

    clickEnEntrega(item) {
      this.entregaSeleccionada = item
    },
    mostrarError(mensaje) {
      store.dispatch("snackbar/mostrar", mensaje)
    }
  },

  created() {
    // if (process.env.NODE_ENV === "development") {
    //   this.fechaHoy = '2021-08-27'
    // } else {
      this.fechaHoy = fechas.getHoy()
    // }

    this.getEntregas()


  }
}
</script>
